'use client'

import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
  ItemActions,
} from '@repo/ui/components'
import { LucideIcon } from '@repo/ui/icons'
import { EllipsisVertical } from 'lucide-react'
import type { ReactNode } from 'react'

export type DetailsItemAction = {
  action: () => void
  icon?: LucideIcon
  label: string
}

export type DetailsItemActionsProp = DetailsItemAction[] | ReactNode

export const DetailsItemActions = ({
  actions,
  menuTitle,
}: {
  actions: DetailsItemActionsProp
  menuTitle?: string
}) => {
  if (!Array.isArray(actions)) return <ItemActions className="shrink-0">{actions}</ItemActions>

  return (
    <ItemActions className="shrink-0" data-sentry-element="ItemActions" data-sentry-component="DetailsItemActions" data-sentry-source-file="details-item-actions.tsx">
      <DropdownMenu data-sentry-element="DropdownMenu" data-sentry-source-file="details-item-actions.tsx">
        <DropdownMenuTrigger
          className="shrink-0"
          render={
            <Button
              aria-label={menuTitle ? `${menuTitle} actions` : 'Actions'}
              size="icon"
              type="button"
              variant="ghost"
            />
          }
        data-sentry-element="DropdownMenuTrigger" data-sentry-source-file="details-item-actions.tsx">
          <EllipsisVertical data-sentry-element="EllipsisVertical" data-sentry-source-file="details-item-actions.tsx" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" data-sentry-element="DropdownMenuContent" data-sentry-source-file="details-item-actions.tsx">
          <DropdownMenuGroup data-sentry-element="DropdownMenuGroup" data-sentry-source-file="details-item-actions.tsx">
            {menuTitle && <DropdownMenuLabel>{menuTitle}</DropdownMenuLabel>}
            {actions.map(action => (
              <DropdownMenuItem key={action.label} onClick={action.action}>
                {action.icon && <action.icon />} {action.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </ItemActions>
  )
}
